module.exports = __webpack_public_path__ + "img/2.d11985c2.jpg";